import { BarChart as MuiBarChart, BarChartProps } from '@mui/x-charts';
import React from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { useLocaleAxes } from 'components/charts/hooks/use-locale-axes';
import { useLocaleSeries } from 'components/charts/hooks/use-locale-series';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const BarChart = React.forwardRef<HTMLDivElement, BarChartProps & ChartSurfaceProps>(function BarChart({ dark, ...props }, ref) {
  const { formatValue } = useChartLocale();
  const series = useLocaleSeries(props.series, formatValue);
  // Matches the native rule for which axis holds the bar categories.
  const horizontal =
    props.layout === 'horizontal' || (props.layout === undefined && series.some((item) => item.layout === 'horizontal'));
  const xAxis = useLocaleAxes(props.xAxis, !horizontal);
  const yAxis = useLocaleAxes(props.yAxis, horizontal);

  return (
    <ChartThemeScope dark={dark}>
      <MuiBarChart {...props} ref={ref} series={series} xAxis={xAxis} yAxis={yAxis} />
    </ChartThemeScope>
  );
});

export default BarChart;
